import { render } from "./HeadingAnalyticsCorrectness.vue?vue&type=template&id=dd446b3a&scoped=true"
import script from "./HeadingAnalyticsCorrectness.vue?vue&type=script&lang=js"
export * from "./HeadingAnalyticsCorrectness.vue?vue&type=script&lang=js"

import "@/css/components/heading-analytics-correctness.css?vue&type=style&index=0&id=dd446b3a&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd446b3a"]])

export default __exports__